module.exports = __webpack_public_path__ + "assets/bxAnalyse.973331c7.svg";